import { render, staticRenderFns } from "./SearchTopBarActions.vue?vue&type=template&id=2066028d&scoped=true&"
import script from "./SearchTopBarActions.vue?vue&type=script&setup=true&lang=js&"
export * from "./SearchTopBarActions.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2066028d",
  null
  
)

export default component.exports